/* eslint-disable no-unused-vars */
import axios from 'axios'
import { buildAirPriceGuideRequest } from './buildAirPriceGuideRequest'
import { getURL } from './helpers'

export function getFlexDates({ request, onlyViewers = false, tripType }) {
  let data = buildAirPriceGuideRequest({ request, tripType, onlyViewers })
  const url = getURL(data?.operationName)

  if (request.showOnly) {
    // TODO: Move to the calling place where the request is built once the SETI is declared
    delete request.showOnly
  }

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data,
    })
      .then(searchResult => {
        // Air Price Guide
        if (onlyViewers & searchResult?.data?.data?.airPriceGuide?.viewers) {
          resolve(searchResult.data.data.airPriceGuide.viewers)
        } else if (searchResult?.data?.data?.airPriceGuide?.records?.length) {
          resolve(searchResult.data.data.airPriceGuide.records)
        } else {
          reject('No valid response received from elastic')
        }

        // eslint-disable-next-line sonarjs/no-redundant-jump
        return
      })
      .catch(error => {
        reject(error)
      })
  })
}
